"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatUrls = void 0;
var FlatFilter_1 = require("./FlatFilter");
function concatUrls() {
    var urls = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        urls[_i] = arguments[_i];
    }
    var filtered = FlatFilter_1.flatfilter(urls);
    return filtered.length > 0 ? "/" + filtered.join("/").replace(/^\/+|\/+$|\/+(\/)/g, "$1") : "";
}
exports.concatUrls = concatUrls;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/helpers/Functions/ConcatUrls.js
// module id = 1527
// module chunks = 8